export default "__VITE_ASSET__KkkzHal6__"